<template>
  <div class="">
    <div class="gap-2 mb-4">
      <input
        ref="fileInput"
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        class="hidden"
        @change="handleFileSelected"
      />
      <button
        class="bg-primary-500 text-white px-3 py-1 rounded-md text-xs"
        :disabled="uploading"
        @click="$refs.fileInput.click()"
      >
        Upload File
      </button>
      <button
        v-if="selectedFile"
        class="flex bg-gray-100 rounded-md text-xs px-2 py-1 mt-2"
      >
        {{ selectedFile.name }}
      </button>
    </div>

    <div v-if="selectedFile" class="gap-2 flex items-center">
      <button
        :disabled="uploading"
        class="bg-green-600 text-white px-3 py-1 rounded-md text-sm flex items-center gap-1"
        @click="uploadImage"
      >
        <Spinning_Loader v-if="uploading" />
        <span>{{ uploading ? 'Uploading...' : 'Upload' }}</span>
      </button>
      <button
        :disabled="uploading"
        class="bg-gray-200 px-3 py-1 rounded-md text-sm"
        @click="cancelUpload"
      >
        Cancel
      </button>
    </div>

    <div v-if="uploadError" class="mt-2 text-red-500 text-sm">
      {{ uploadError }}
    </div>

    <div
      v-if="uploadSuccess"
      class="mt-2 bg-green-700 text-white text-sm border p-1 rounded-md"
    >
      Image uploaded successfully!
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinning_Loader from '@/components/widgetcomponents/Viz_Elements/Spinning_Loader.vue';

export default {
  components: {
    Spinning_Loader,
  },
  props: {
    relatedObjectId: {
      type: Number,
      required: true,
    },
    relatedObjectContentTypeModel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedFile: null,
      uploading: false,
      uploadError: '',
      uploadSuccess: false,
      imageUrl: '',
      imageKey: '',
    };
  },
  methods: {
    handleFileSelected(e) {
      const file = e.target.files[0];
      if (file) {
        if (file.size > 5 * 1024 * 1024) {
          // 5MB limit
          this.uploadError = 'File size exceeds 5MB limit';
          return;
        }
        this.selectedFile = file;
        this.uploadError = '';
      }
    },

    async uploadImage() {
      if (!this.selectedFile) {
        return;
      }

      this.uploading = true;
      this.uploadError = '';

      try {
        // Create form data to send the file
        const formData = new FormData();
        formData.append('file', this.selectedFile);

        // Add optional parameters if needed
        formData.append('object_type', this.relatedObjectContentTypeModel);
        formData.append('object_id', this.relatedObjectId);

        // Upload the file to backend
        const response = await axios.post('/api/media/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response.data.success) {
          // Store the image key for future reference
          this.imageKey = response.data.key;
          this.uploadSuccess = true;
          // Show the image using the provided URL
          this.imageUrl = response.data.url;

          // Emit an event to notify parent component about the upload
          this.$emit('image-uploaded', {
            key: this.imageKey,
          });
        } else {
          this.uploadError =
            'Upload failed: ' + (response.data.error || 'Unknown error');
        }
      } catch (error) {
        console.error('Error uploading image:', error);
        this.uploadError =
          error.response?.data?.error || 'Failed to upload image';
      } finally {
        this.uploading = false;
        this.selectedFile = null;
        this.$refs.fileInput.value = '';
      }
    },
    cancelUpload() {
      this.selectedFile = null;
      this.$refs.fileInput.value = '';
    },
  },
  mounted() {
    // If there's already an associated image, fetch it
    if (this.taskMetadata && this.taskMetadata.imageKey) {
      this.imageKey = this.taskMetadata.imageKey;
      this.fetchImageUrl();
    }
  },
};
</script>
